import React, { Component } from 'react';

class AdminUnsupported extends Component<any, any> {
  constructor(props){
    super(props);
  }

  render() {
    return (
      <div>
        Unsupported
      </div>
    )
  }

}

export default AdminUnsupported
